module.exports = __webpack_public_path__ + "img/selected_baggage.41654e2b.svg";